module.exports = __webpack_public_path__ + "img/my.1bfe5350.png";